import * as antlr4 from 'antlr4';
import DataLexer from './DataLexer';
import DataParser from './DataParser';

function findAllRuleNodes(tree: any, ruleIndex: number): any[] {
    const nodes: any[] = [];
    if (tree.ruleIndex === ruleIndex) {
        nodes.push(tree);
    }
    if (tree.children) {
        for (const child of tree.children) {
            nodes.push(...findAllRuleNodes(child, ruleIndex));
        }
    }
    return nodes;
}

class SyntaxErrorListener extends antlr4.ErrorListener<antlr4.Token> {
    errors: string[];

    constructor(errors: string[]) {
        super();
        this.errors = errors;
    }

    syntaxError(rec: any, sym: antlr4.Token, line: number, col: number, msg: string, e: any): void {
        this.errors.push("Syntax error: unexpected token \"" + sym.text + "\" at position " + col + ".");
    }
}

const getValidationErrors = (value: string | undefined, fieldNames?: string[]): string[] | false => {
    if (value === undefined) {
        return false;
    }
    let inputStream = antlr4.CharStreams.fromString(value);
    let dataLexer = new DataLexer(inputStream);
    let errors: string[] = [];
    let commonTokenStream = new antlr4.CommonTokenStream(dataLexer);
    let dataParser = new DataParser(commonTokenStream);
    let errorListener = new SyntaxErrorListener(errors);
    dataParser.addErrorListener(errorListener);
    let context = dataParser.line();

    if(fieldNames){
        let names = findAllRuleNodes(context, DataParser.RULE_name);
        let vars: string[] = [];
        for (let i = 0; i < names.length; i++)
        {
            let text = names[i].getText();
            if (text) {
                vars.push(text);
            }
        }
        // COMBINE with the parser syntax errors already collected — do NOT overwrite
        // them, or a syntactically invalid expression whose referenced fields all happen
        // to be whitelisted (e.g. 'sku +' with ['sku']) is falsely reported valid.
        errors = errors.concat(vars.filter(r => fieldNames.indexOf(r) === -1).map(r => `Invalid field ${r}.`));
    }

    return errors;
}

const isValidExpression = (value: string | undefined | null, fieldNames?: string[]): boolean => {
    if (value === undefined || value === null || value === '') {
        return false;
    }
    let errors = getValidationErrors(value, fieldNames);
    return !errors || errors.length === 0;
}

const getErrorMessage = (value: string | undefined, fieldNames?: string[]): string | undefined => {
    var errors = getValidationErrors(value, fieldNames);
    return (!errors || errors.length === 0) ? undefined : errors.join();
};

export {isValidExpression, getErrorMessage, getValidationErrors};
